module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-bg.c529ab79.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-bg.png
// module id = 2509
// module chunks = 11